import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getWarehouseGroupList as getWarehouseGroupListApi,
	getWarehouseGroup as getWarehouseGroupApi,
	addNewWarehouseGroup as addNewWarehouseGroupApi,
	updateWarehouseGroup as updateWarehouseGroupApi,
	deleteWarehouseGroup as deleteWarehouseGroupApi,
	checkWarehouseGroupExists as checkWarehouseGroupExistsApi
} from '../../helpers/warehouse/backend_helper';

export const getWarehouseGroupList = createAsyncThunk('warehouse_categories/getWarehouseGroupList', async (params) => {
	try {
		const response = getWarehouseGroupListApi(params);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getWarehouseGroup = createAsyncThunk('warehouse_categories/getWarehouseGroup', async warehouse_category_id => {
	try {
		const response = getWarehouseGroupApi(warehouse_category_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewWarehouseGroup = createAsyncThunk('warehouse_categories/addNewWarehouseGroup', async warehouse_category => {
	try {
		const response = addNewWarehouseGroupApi(warehouse_category);
		toast.success('Categoría agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar la categoría.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateWarehouseGroup = createAsyncThunk('warehouse_categories/updateWarehouseGroup', async (warehouse_category) => {
		try {
			console.log('comienza??')
			const response = updateWarehouseGroupApi(warehouse_category);
			toast.success('Categoría actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar la categoría.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteWarehouseGroup = createAsyncThunk('warehouse_categories/deleteWarehouseGroup', async warehouse_category => {
	try {
		const response = await deleteWarehouseGroupApi(warehouse_category);
		toast.success('Categoría eliminado exitosamente.', { autoClose: 3000 });
		return { warehouse_category, ...response };
	} catch (error) {
		toast.error('Error al eliminar la categoría.', { autoClose: 3000 });
		throw new Error(error);
	}
});


export const checkWarehouseGroupExists = createAsyncThunk('warehouse_categories/checkWarehouseGroupExists', async name => {
	try {
		const response = await checkWarehouseGroupExistsApi(name);
		return response;
	} catch (error) {
		throw new Error(error.message);
	}
});